import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetNameFragment = { __typename?: 'NotificationLayoutItemAssetName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } };

export type ChipFragment = { __typename?: 'NotificationLayoutItemChip', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip', color?: string | null } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText' }, avatar?: { __typename?: 'NotificationAvatar', color?: Types.AvatarColor | null, url?: string | null, userName: string } | null };

export type TextFragment = { __typename?: 'NotificationLayoutItemText', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } };

export type UserNameFragment = { __typename?: 'NotificationLayoutItemUserName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } };

export type NotificationLayoutItemProjectNameFragment = { __typename?: 'NotificationLayoutItemProjectName', content: string, style: { __typename?: 'NotificationLayoutItemStyleChip' } | { __typename?: 'NotificationLayoutItemStyleSection' } | { __typename?: 'NotificationLayoutItemStyleText', fontWeight: Types.NotificationLayoutItemStyleTextFontStrength } };

export const AssetName = /*#__PURE__*/ gql`
    fragment AssetName on NotificationLayoutItemAssetName {
  content
  style {
    ... on NotificationLayoutItemStyleText {
      fontWeight
    }
  }
}
    ` as unknown as DocumentNode<AssetNameFragment, unknown>;
export const Chip = /*#__PURE__*/ gql`
    fragment Chip on NotificationLayoutItemChip {
  content
  style {
    ... on NotificationLayoutItemStyleChip {
      color
    }
  }
  avatar {
    color
    url
    userName
  }
}
    ` as unknown as DocumentNode<ChipFragment, unknown>;
export const Text = /*#__PURE__*/ gql`
    fragment Text on NotificationLayoutItemText {
  content
  style {
    ... on NotificationLayoutItemStyleText {
      fontWeight
    }
  }
}
    ` as unknown as DocumentNode<TextFragment, unknown>;
export const UserName = /*#__PURE__*/ gql`
    fragment UserName on NotificationLayoutItemUserName {
  content
  style {
    ... on NotificationLayoutItemStyleText {
      fontWeight
    }
  }
}
    ` as unknown as DocumentNode<UserNameFragment, unknown>;
export const NotificationLayoutItemProjectName = /*#__PURE__*/ gql`
    fragment NotificationLayoutItemProjectName on NotificationLayoutItemProjectName {
  content
  style {
    ... on NotificationLayoutItemStyleText {
      fontWeight
    }
  }
}
    ` as unknown as DocumentNode<NotificationLayoutItemProjectNameFragment, unknown>;

        

        
export const useAssetNameFragment = (
  input: string | Omit<UseFragmentOptions<AssetNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayoutItemAssetName' } };
    return input;
  })();

  return useFragment<AssetNameFragment>({
    fragment: AssetName,
    fragmentName: 'AssetName',
    ...options,
  });
};
  
        
        

        
export const useChipFragment = (
  input: string | Omit<UseFragmentOptions<ChipFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayoutItemChip' } };
    return input;
  })();

  return useFragment<ChipFragment>({
    fragment: Chip,
    fragmentName: 'Chip',
    ...options,
  });
};
  
        
        

        
export const useTextFragment = (
  input: string | Omit<UseFragmentOptions<TextFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayoutItemText' } };
    return input;
  })();

  return useFragment<TextFragment>({
    fragment: Text,
    fragmentName: 'Text',
    ...options,
  });
};
  
        
        

        
export const useUserNameFragment = (
  input: string | Omit<UseFragmentOptions<UserNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayoutItemUserName' } };
    return input;
  })();

  return useFragment<UserNameFragment>({
    fragment: UserName,
    fragmentName: 'UserName',
    ...options,
  });
};
  
        
        

        
export const useNotificationLayoutItemProjectNameFragment = (
  input: string | Omit<UseFragmentOptions<NotificationLayoutItemProjectNameFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationLayoutItemProjectName' } };
    return input;
  })();

  return useFragment<NotificationLayoutItemProjectNameFragment>({
    fragment: NotificationLayoutItemProjectName,
    fragmentName: 'NotificationLayoutItemProjectName',
    ...options,
  });
};
  
        